var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/nodes/iconText.ts
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex";
import "@adornis/chemistry/elements/components/x-icon";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import {
  ICON_TEXT_KEY,
  ICON_TEXT_SCHEMA,
  ICON_WRAPPER_KEY,
  ICON_WRAPPER_SCHEMA,
  TEXT_WRAPPER_KEY,
  TEXT_WRAPPER_SCHEMA
} from "../../schema/nodes/icon-text.js";
import { ICON_KEY } from "../../schema/nodes/icon.js";
import { BuildifyLitElement } from "../BuildifyLitElement.js";
import { runInsertNode } from "../helper/runInsertNode.js";
import { isNodeSelection } from "../util.js";
var iconText = () => ({
  node: {
    name: ICON_TEXT_KEY,
    schema: ICON_TEXT_SCHEMA()
  },
  menuItems: [
    {
      label: "Icon mit Text",
      icon: "skull_list",
      run: (view) => runInsertNode(ICON_TEXT_KEY, (state) => {
        return {
          content: [
            state.schema.nodes[ICON_WRAPPER_KEY].create(null, [state.schema.nodes[ICON_KEY].create()]),
            state.schema.nodes[TEXT_WRAPPER_KEY].create(null, [
              state.schema.nodes.paragraph.create(null, [state.schema.text("\xC4ndere mich...")])
            ])
          ]
        };
      })(view.state, view),
      shouldVisualize: (view) => {
        return !isNodeSelection(view.state.selection);
      }
    }
  ]
});
var iconWrapper = () => ({
  node: {
    name: ICON_WRAPPER_KEY,
    schema: ICON_WRAPPER_SCHEMA()
  }
});
var textWrapper = () => ({
  node: {
    name: TEXT_WRAPPER_KEY,
    schema: TEXT_WRAPPER_SCHEMA()
  }
});
var NodeIconText = class extends BuildifyLitElement {
  content({ content, mode }) {
    return html`
      <x-flex horizontal crossaxis-center ${css({ gap: "8px" })}>
        <slot name="icon"></slot>
        <slot name="title"></slot>
      </x-flex>
    `;
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          //   fontSize: '20px',
          whiteSpace: "normal",
          display: "inline-block",
          verticalAlign: "middle"
        }
      }
    ];
  }
};
NodeIconText = __decorateClass([
  customElement("node-icon-text")
], NodeIconText);
export {
  NodeIconText,
  iconText,
  iconWrapper,
  textWrapper
};
